<div class="card mt-4">
    <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbContact"></p-breadcrumb>
</div>
<div class="card mt-4">

    <div class="font-semibold text-xl mb-4">Liste des Contacts - {{this.nomDo}} - {{this.do}} </div>

    <p-toolbar styleClass="mb-6">
        <ng-template #start>
            <p-button label="Ajouter" (onClick)="openNewContact()" icon="pi pi-plus" class="mr-2" />
            <p-button severity="secondary" label="Désactiver" icon="pi pi-times" outlined class="mr-2"
                [style]="{'color': 'var(--primary-color)'}" [disabled]="!selectedContacts || !selectedContacts.length || allSelectedContactsInactive() || hasMixedSelection() "
                (onClick)="disableSelectedContacts()" />
             <p-button severity="secondary" label="Activer" icon="pi pi-check" outlined
                [style]="{'color': 'var(--primary-color)'}" [disabled]="!selectedContacts || !selectedContacts.length || allSelectedContactsActive() || hasMixedSelection()"
                (onClick)="enableSelectedContacts()" />
        </ng-template>

        <!-- <ng-template #end>
                <p-button label="Export" icon="pi pi-upload" severity="secondary" (onClick)="exportCSV()" />
            </ng-template> -->
    </p-toolbar>
    <p-table #dt1 dataKey="code_interne" [value]="contacts" [rows]="10" [rowHover]="true" [showGridlines]="true"
        [paginator]="true" [loading]="loading" [(selection)]="selectedContacts" [globalFilterFields]="
                ['Code_DO', 'code_interne', 'code_Societe', 'Nom_Societe', 'Nom', 'Prenom',
                 'Tel1', 'Tel2', 'Tel3', 'Fax' , 'AdrEmail',
                 'Adresse', 'Code_Postal', 'Ville', 'Service', 'Fonction',
                 'DateModif','AgentModif','Civilite','FlagActif'
                ]" responsiveLayout="scroll" [tableStyle]="{ 'min-width': '75rem' }"
        currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} contacts"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="rowsPerPageOptions">
        <ng-template #caption>
            <div class="flex justify-between items-center flex-column sm:flex-row">
                <button pButton label="Réintialiser" class="p-button-outlined mb-2" icon="pi pi-filter-slash"
                    (click)="clear(dt1)"></button>
                <p-iconfield iconPosition="left" class="ml-auto">
                    <p-inputicon>
                        <i class="pi pi-search"></i>
                    </p-inputicon>
                    <input pInputText type="text" (input)="onGlobalFilter(dt1, $event)" placeholder="Rechercher..." />
                </p-iconfield>
            </div>
        </ng-template>
        <ng-template #header>
            <tr>
                <th style="width: 2rem">
                    <p-tableHeaderCheckbox />
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold">Code Société</span>
                        <p-columnFilter type="text" field="code_Societe" display="menu"
                            placeholder="Rechercher par code société"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Nom Société
                        <p-columnFilter type="text" field="Nom_Societe" display="menu"
                            placeholder="Rechercher par nom de société"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Nom Contact
                        <p-columnFilter type="text" field="Nom" display="menu"
                            placeholder="Rechercher par nom de contact"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Prénom Contact
                        <p-columnFilter type="text" field="Prenom" display="menu"
                            placeholder="Rechercher par prénom de contact"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Téléphone 1
                        <p-columnFilter type="text" field="Tel1" display="menu"
                            placeholder="Rechercher par numéro de téléphone 1"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Adresse E-mail
                        <p-columnFilter type="text" field="AdrEmail" display="menu"
                            placeholder="Rechercher par adresse email"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Statut
                        <p-columnFilter field="FlagActif" matchMode="equals" display="menu">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-select [ngModel]="value" [options]="statusOptions" (onChange)="filter($event.value)" placeholder="Rechercher par Statut" [style]="{ 'min-width': '12rem' }">
                                            <ng-template let-option #item>
                                                <span [class]="'customer-badge status-' + option.value">{{ option.label }}</span>
                                            </ng-template>
                                        </p-select>
                                    </ng-template>
                                </p-columnFilter>
                    </div>
                </th>
                <th style="width: 6rem; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-center items-center">
                        Actions
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template #body let-contact>
            <tr>
                <td style="width: 3rem">
                    <p-tableCheckbox [value]="contact" />
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span>{{ contact.code_Societe }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span>{{ contact.Nom_Societe }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span>{{ contact.Nom }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span>{{ contact.Prenom }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span>{{ contact.Tel1 }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span>{{ contact.AdrEmail }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex items-center justify-center gap-2">
                        <p-toggleSwitch 
                            [(ngModel)]="contact.FlagActif" 
                            (onChange)="onToggleChange(contact)"
                            [trueValue]="1" 
                            [falseValue]="0"
                            [disabled]="contact.toggleLoading"
                            class="scale-90">
                        <ng-template #handle let-checked="checked">
                            <i [ngClass]="{'!text-xs pi': true, 'pi-check': checked, 'pi-times': false}"></i>
                        </ng-template>
                        </p-toggleSwitch> 
                          <span class="font-semibold w-20"> {{ contact.FlagActif === 1 ? 'Activé' : 'Désactivé' }}</span>
                    </div>
                </td>

                <td>
                    <div class="flex items-center justify-center">
                        <p-button icon="pi pi-eye" (onClick)="openDetailsContact(contact)" class="mr-1" [rounded]="true"
                            [outlined]="true" />
                        <p-button icon="pi pi-pencil" (onClick)="openUpdateContact(contact)" severity="danger"
                            [rounded]="true" class="mr-1" [outlined]="true" />
                        <!-- <p-button icon="pi pi-trash" (click)="deleteByContact(contact)" severity="danger"
                            [rounded]="true" class="mr-4" [outlined]="true" /> -->                      
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="9">Aucun contact trouvé.</td>
            </tr>
        </ng-template>
        <ng-template #loadingbody>
            <tr>
                <td colspan="9">Chargement des données contacts. Veuillez patienter.</td>
            </tr>
        </ng-template>
    </p-table>


    <!-- Bloc d'ajout Contact -->
    <p-dialog [(visible)]="addContactDialog" [style]="{ width: '1000px' }" header="Ajouter Contact" [modal]="true">
        <ng-template #content>
            <div class="flex flex-col gap-6">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Code Société <span class="text-red-500">*</span></label>
                        <p-dropdown [options]="listCodeSociete" [(ngModel)]="selectedCodeSociete" filterBy="code,name"
                            placeholder="Select Code Société" [filter]="true" [showClear]="true" [virtualScroll]="true" [virtualScrollItemSize]="34"
                            [class]="{'p-invalid': submitted && !selectedCodeSociete}" class="w-full">
                            <ng-template pTemplate="selectedItem">
                                @if (selectedCodeSociete) {
                                <div class="flex items-center">
                                    <span [class]="'mr-2' + selectedCodeSociete.code"
                                        style="width: 18px; height: 12px"></span>
                                    <div>{{ selectedCodeSociete.code }}</div>
                                </div>
                                }
                            </ng-template>
                            <ng-template let-societeCode pTemplate="item">
                                <div class="flex items-center">
                                    <span [class]="'mr-2' + societeCode.code" style="width: 18px; height: 12px"></span>
                                    <div>{{ societeCode.code }} - {{ societeCode.name }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                        <p-message *ngIf="submitted && !selectedCodeSociete" severity="error" variant="simple"
                            size="small">
                            Le code société est obligatoire
                        </p-message>
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Civilité <span class="text-red-500">*</span></label>
                        <p-selectbutton [(ngModel)]="selectButtonValue" [options]="selectButtonValues"
                            optionLabel="name" [class]="{'p-invalid': submitted && !selectButtonValue}" />
                        <p-message *ngIf="submitted && !selectButtonValue" severity="error" variant="simple"
                            size="small">
                            La civilité est obligatoire
                        </p-message>
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Nom <span class="text-red-500">*</span></label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Nom"
                            [class]="{'p-invalid': submitted && !contact.Nom}" />
                        <p-message *ngIf="submitted && !contact.Nom" severity="error" variant="simple" size="small">
                            Le nom est obligatoire
                        </p-message>
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Prénom </label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Prenom"
                            [class]="{'p-invalid': submitted && !contact.Prenom}" />
                        <!-- <p-message *ngIf="submitted && !contact.Prenom" severity="error" variant="simple" size="small">
                            Le prénom est obligatoire
                        </p-message> -->
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-1 gap-1">
                    <div>
                        <label class="block font-bold mb-2">Adresse</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Adresse"
                            class="w-full"  />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Ville</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Ville"
                            class="w-full"  />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Code Postal</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Code_Postal"
                           class="w-full"  />
                    </div>
                </div>

                <p-divider class="w-full bg-surface-200"></p-divider>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Téléphone 1 <span class="text-red-500">*</span></label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Tel1"
                            [class]="{'p-invalid': submitted && !contact.Tel1}" />
                        <p-message *ngIf="submitted && !contact.Tel1" severity="error" variant="simple" size="small">
                            Le téléphone 1 est obligatoire
                        </p-message>
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Téléphone 2</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Tel2" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Téléphone 3</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Tel3" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Fax</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Fax" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Adresse E-mail</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.AdrEmail" 
                        [class]="{'p-invalid': submitted && contact.AdrEmail && !isValidEmail(contact.AdrEmail)}"/>
                        <p-message *ngIf="submitted && contact.AdrEmail && !isValidEmail(contact.AdrEmail)" 
                            severity="error" variant="simple" size="small">
                             Veuillez entrer une adresse mail valide
                        </p-message>
                    </div>
                </div>

                <p-divider class="w-full bg-surface-200"></p-divider>

                <div class="grid grid-cols-1 sm:grid-cols-1 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Fonction</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Fonction" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-1 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Service</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Service" />
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #footer>
            <p-button label="Annuler" icon="pi pi-times" text (click)="hideDialog()" />
            <p-button label="Enregistrer" icon="pi pi-save" [disabled]="isDisable" (click)="validateAndSaveContact()" />
        </ng-template>
    </p-dialog>

    <!-- Bloc de détails du contact -->
    <p-dialog [(visible)]="detailsContactDialog" [style]="{ width: '1000px' }" header="Détails du Contact" [modal]="true"
        [draggable]="false" [resizable]="false">
        <ng-template #content>
            <div class="flex flex-col gap-6" *ngIf="selectedcontactItem">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <div>
                        <label class="block font-bold mb-2">Code Société</label>
                        <input type="text" pInputText [value]="selectedcontactItem.code_Societe" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Nom Société</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Nom_Societe" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>

                <p-divider class="w-full bg-surface-200"></p-divider>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Civilité</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Civilite" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Nom</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Nom" [readOnly]="true"
                            class="w-full" />

                    </div>
                    <div>
                        <label class="block font-bold mb-2">Prénom</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Prenom" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-1 gap-1">
                    <div>
                        <label class="block font-bold mb-2">Adresse</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Adresse" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Ville</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Ville" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Code Postal</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Code_Postal" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>

                <p-divider class="w-full bg-surface-200"></p-divider>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Téléphone 1</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Tel1" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Téléphone 2</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Tel2" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Téléphone 3</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Tel3" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Fax</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Fax" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Adresse E-mail</label>
                        <input type="text" pInputText [value]="selectedcontactItem.AdrEmail" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>

                <p-divider class="w-full bg-surface-200"></p-divider>

                <div class="grid grid-cols-1 sm:grid-cols-1 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Fonction</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Fonction" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-1 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Service</label>
                        <input type="text" pInputText [value]="selectedcontactItem.Service" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Agent modification</label>
                        <input type="text" pInputText [value]="selectedcontactItem.AgentModif" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Date modification</label>
                        <input type="text" pInputText [value]="selectedcontactItem.DateModif | date: 'dd/MM/yyyy HH:mm a'" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #footer>
            <p-button label="Annuler" icon="pi pi-times" text (click)="hideDialog()" />
        </ng-template>
    </p-dialog>

    <!-- Bloc de modification Contact -->
    <p-dialog [(visible)]="updateContactDialog" [style]="{ width: '1000px' }" header="Modifier Contact" [modal]="true">
        <ng-template #content>
            <div class="flex flex-col gap-6">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Code Société <span class="text-red-500">*</span></label>
                        <p-dropdown [options]="listCodeSociete" [(ngModel)]="selectedCodeSociete" filterBy="code,name"
                            placeholder="Select Code Société" [filter]="true" [showClear]="true" [virtualScroll]="true" [virtualScrollItemSize]="34"
                            [class]="{'p-invalid': submitted && !selectedCodeSociete}" class="w-full">
                            <ng-template pTemplate="selectedItem">
                                @if (selectedCodeSociete) {
                                <div class="flex items-center">
                                    <span [class]="'mr-2' + selectedCodeSociete.code"
                                        style="width: 18px; height: 12px"></span>
                                    <div>{{ selectedCodeSociete.code }}</div>
                                </div>
                                }
                            </ng-template>
                            <ng-template let-societeCode pTemplate="item">
                                <div class="flex items-center">
                                    <span [class]="'mr-2' + societeCode.code" style="width: 18px; height: 12px"></span>
                                    <div>{{ societeCode.code }} - {{ societeCode.name }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                        <p-message *ngIf="submitted && !selectedCodeSociete" severity="error" variant="simple"
                            size="small">
                            Le code société est obligatoire
                        </p-message>
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Civilité <span class="text-red-500">*</span></label>
                        <p-selectbutton [(ngModel)]="selectButtonValue" [options]="selectButtonValues"
                            optionLabel="name" [class]="{'p-invalid': submitted && !selectButtonValue}" />
                        <p-message *ngIf="submitted && !selectButtonValue" severity="error" variant="simple"
                            size="small">
                            La civilité est obligatoire
                        </p-message>
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Nom <span class="text-red-500">*</span></label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Nom"
                            [class]="{'p-invalid': submitted && !contact.Nom}" />
                        <p-message *ngIf="submitted && !contact.Nom" severity="error" variant="simple" size="small">
                            Le nom est obligatoire
                        </p-message>
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Prénom </label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Prenom"
                            [class]="{'p-invalid': submitted && !contact.Prenom}" />
                        <!-- <p-message *ngIf="submitted && !contact.Prenom" severity="error" variant="simple" size="small">
                            Le prénom est obligatoire
                        </p-message> -->
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-1 gap-1">
                    <div>
                        <label class="block font-bold mb-2">Adresse</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Adresse"/>
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Ville</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Ville"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Code Postal</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Code_Postal"
                            class="w-full" />
                    </div>
                </div>

                <p-divider class="w-full bg-surface-200"></p-divider>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Téléphone 1 <span class="text-red-500">*</span></label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Tel1"
                            [class]="{'p-invalid': submitted && !contact.Tel1}" />
                        <p-message *ngIf="submitted && !contact.Tel1" severity="error" variant="simple" size="small">
                            Le téléphone 1 est obligatoire
                        </p-message>
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Téléphone 2</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Tel2" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Téléphone 3</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Tel3" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Fax</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Fax" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Adresse E-mail</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.AdrEmail"
                            [class]="{'p-invalid': submitted && contact.AdrEmail && !isValidEmail(contact.AdrEmail)}" />
                        <p-message *ngIf="submitted && contact.AdrEmail && !isValidEmail(contact.AdrEmail)" 
                                    severity="error" variant="simple" size="small">
                                Veuillez entrer une adresse mail valide
                        </p-message>
                    </div>
                </div>

                <p-divider class="w-full bg-surface-200"></p-divider>

                <div class="grid grid-cols-1 sm:grid-cols-1 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Fonction</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Fonction" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-1 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Service</label>
                        <input type="text" pInputText class="w-full" [(ngModel)]="contact.Service" />
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #footer>
            <p-button label="Annuler" icon="pi pi-times" text (click)="hideDialog()" />
            <p-button label="Enregistrer" icon="pi pi-save" [disabled]="isDisable" (click)="validateAndUpdateContact(contact.code_interne)" />
        </ng-template>
    </p-dialog>


    <p-confirmdialog [style]="{ width: '850px' }" />
    <p-toast />

</div>